import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faChevronLeft,
	faChevronRight,
	faEnvelope,
	faPlay,
	faStop,
	faWindowClose
} from '@fortawesome/free-solid-svg-icons'
import {
	FontAwesomeIcon,
	FontAwesomeLayers,
	FontAwesomeLayersText
} from '@fortawesome/vue-fontawesome'
import Vue from 'vue'

library.add(faPlay)
library.add(faEnvelope)
library.add(faStop)
library.add(faChevronLeft)
library.add(faChevronRight)
library.add(faChevronRight)
library.add(faWindowClose)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
